export default "__VITE_ASSET__BPjSeCU5__"